import { ToggleKeys } from '../Constants';

export const isToggledOnn = ({ toggles, key }) => {
  if (!key) return false;
  if (!toggles) return true;
  if (toggles && !(key in toggles)) return true;

  return (ToggleKeys.ALL[window.__VENDOR__] in toggles && toggles[ToggleKeys.ALL[window.__VENDOR__]]) || (key in toggles && toggles[key]);
};
